import React from 'react';
import OperationsOverview from './OperationsOverview';
import Sales from './Sales';
import FoodCost from './FoodCost';
import LaborCosts from './LaborCosts';

// Operations hub. Hosts financial / staffing daily-ops surfaces:
//   Overview / Sales / Food Costs / Labor Costs
//
// The Cost Dashboard moved to INVENTORY · Dashboard in the dashboard
// restructure commit — operators reach for it as part of their
// purchasing flow, not their financial-ops flow. Operations went back to
// being the prime-cost / staffing surface it was originally.
//
// Price Tracker, Inventory Trends, Menu, Menu Coach moved out of Operations
// and into their own top-level Inventory and Menu groups in the sidebar.
// See DESIGN_SYSTEM.md §Three-group nav.
//
// No in-page underline tab strip. The sidebar's OPERATIONS group renders all
// sub-items as direct nav links — an in-page strip would just duplicate the
// same control. See DESIGN_SYSTEM.md §Sidebar groups always expanded.
//
// Cross-tab navigation flows through the top-level `app:navigate` listener
// in App.js (see src/lib/navigate.js) — Operations is no longer a switchboard.

export default function Operations({ companyId, initialTab = 'overview' }) {
  const tab = initialTab;

  switch (tab) {
    case 'overview': return <OperationsOverview companyId={companyId} />;
    case 'sales':    return <Sales companyId={companyId} />;
    case 'food':     return <FoodCost companyId={companyId} />;
    case 'labor':    return <LaborCosts companyId={companyId} />;
    default:         return null;
  }
}
